export type I_statusId = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7
export type I_statusDic = { [key in I_statusId]: string }

export type I_vehicleType = 0 | 1
export type I_vehicleTypeDic = { [key in I_vehicleType]: string }
export const vehicleTypeDic: I_vehicleTypeDic = {
    '0': 'وانت',
    '1': 'کامیون'
}

export type I_midmileTrip = {
    driverName: string,
    driverMobile: string,
    numberOfBags: number,
    numberOfConsignments: number,
    driverId: number,
    vehicleType: { id: number,text:string },
    currentStatus: { id: I_statusId,text:string},
    nextStatus?: { id: I_statusId,text:string},
    tripNumber: string,
    sourceHub: { name: string,id:number,latitude:number,longitude:number},
    plate: string[],
    pos: [number, number],
    id: number,
    index?: number,
    timeToArriveInNextStatus?:number
}